module.exports = __webpack_public_path__ + "img/2.2735e406.png";